import "./App.scss"
import Header from "./Header"

function App() {
  return (
    <div className="App">
      <Header />
    </div>
  )
}

export default App
